import { Box } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export interface LogoProps {
    widthOverride?: string
    heightOverride?: string
}

const BlueLogo: React.FC<LogoProps> = ({
    widthOverride = getPxAsRem(100),
    heightOverride = 'auto',
}) => {
    return (
        <Box
            height={heightOverride}
            width={widthOverride}
            component={'img'}
            src={'/cpi_blue_logo.png'}
            alt="CPI logo"
        />
    )
}

export default BlueLogo
